export default "__VITE_ASSET__DouyCV6g__"